import React, { useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import filtersearch from "../assets/images/icon/filter-search.png";
import Input from 'components/Input';
import Select from 'components/Select';
import Checkbox from 'components/Checkbox';


function AddWorkPlacesModal({
    open,
    onClose
}) {
    return (
        <Modal className='add-workplace-modal' show={open} onHide={onClose} centered>
            <div className="modal-header border-0 pb-0 d-flex justify-content-between align-items-center">
                <h4 classNam="sub-title mb-0">Add Workiplace</h4>
                <button type="button" className="close bg-transparent border-0" onClick={onClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <Modal.Body className='pt-0'>
                <div>
                    <h2 className='sub-title workplace-information-title mb-0'>Workplace Information</h2>
                    <p className='gray-title my-2'>Workplace Id</p>
                    <h6 className='id-title fw-medium text-black m-0'>0ca0139f-bb34-ef11-86c3-6045bdc7c4f5</h6>
                </div>
                <form>
                    <div className='row mt-3'>
                        <div className='col-12'>
                            <label>Workplace Name</label>
                            <Input
                                variant='flat'
                                fullWidth
                                placeholder='Enter Name'
                            />
                        </div>
                        <div className='my-3'>
                            <h2 className='sub-title workplace-information-title mb-0'>Address Information</h2>
                        </div>
                        <div className='col-lg-6'>
                            <label>Street 1*</label>
                            <Input
                                variant='flat'
                                fullWidth
                                placeholder='Street 1'
                            />
                        </div>
                        <div className='col-lg-6'>
                            <label>Street 2*</label>
                            <Input
                                variant='flat'
                                fullWidth
                                placeholder='Street 2'
                            />
                        </div>
                        <div className='col-lg-4 mt-3'>
                            <label>City*</label>
                            <Input
                                variant='flat'
                                fullWidth
                                placeholder='Enter city'
                            />
                        </div>
                        <div className='col-lg-4 mt-3'>
                            <label>State</label>
                            <Select
                                fullWidth
                                placeholder='Select State'
                            />
                        </div>
                        <div className='col-lg-4 mt-3'>
                            <label>Zip Code</label>
                            <Input
                                variant='flat'
                                fullWidth
                                placeholder='Enter zipcode'
                            />
                        </div>
                        <div className='my-4'>
                            <h2 className='sub-title workplace-information-title mb-0'>Timekeeping Information</h2>
                        </div>
                        <div className='col-lg-6'>
                            <label>Workplace Time zone*</label>
                            <Input
                                variant='flat'
                                fullWidth
                                placeholder='8'
                            />
                        </div>
                        <div className='col-lg-6'>
                            <label>Weekly Overtime Hours Start</label>
                            <Input
                                variant='flat'
                                fullWidth
                                placeholder='40'
                            />
                        </div>
                        <div className='col-lg-6 mt-3'>
                            <label>Daily Double OT Hours Start</label>
                            <Input
                                variant='flat'
                                fullWidth
                                placeholder='40'
                            />
                        </div>
                        <div className='col-lg-6 mt-3'>
                            <label>Weekly Double OT Hours Start</label>
                            <Input
                                variant='flat'
                                fullWidth
                                placeholder='40'
                            />
                        </div>
                    </div>
                    <div className="form-check mt-4">
                        <Checkbox
                            size='small'
                            label='Enable Paid Meal Breaks'
                        />
                    </div>
                    <div className="form-check mt-4">
                        <Checkbox
                            size='small'
                            label='Enable Paid Rest Breaks'
                        />
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className='border-0 justify-content-start mb-5'>
                <Button className='button-orange'>
                    Add Workplace
                </Button>
            </Modal.Footer>
        </Modal>
    );
}


export default AddWorkPlacesModal;
